import React from 'react';
import styled from 'styled-components';
import { Checkbox } from 'assets';
import { useHistory } from 'react-router-dom';
import { Paths } from 'routes';
import { useTheme } from 'hooks';
import { TRANSLATIONS_VALUES_KEYS } from 'redux/internationalization/internationalization';
import { useTranslate } from 'services';

const {
  terms_of_service: {
    terms_and_conditions_agreement_text,
    terms_and_conditions_agreement_document_link_text
  },
} = TRANSLATIONS_VALUES_KEYS;

const Container = styled.div`
  display: flex;
  align-items: center;
  text-align: start;
  font-weight: bold;
  font-size: 0.75rem;
`;

const TermsOfConditionsPdf = styled.span<{ color?: string }>`
  background-color: transparent;
  border: 0;
  color: ${({ color }) => color};
  text-decoration: underline;
  font-weight: bold;
`;

const CheckboxWrapper = styled.div`
  padding-left: 0.813rem;
  padding-right: 2rem;
  width: 2.063rem;
`;

const TextWrapper = styled.div`
`;

type TermsAndConditionsProps = {
  isAccessGrantingInProgress: boolean;
  isTermsAndConditionsAccepted: boolean;
  setIsTermsAndConditionsAccepted: (value: boolean) => void;
}

const TermsAndConditions : React.FC<TermsAndConditionsProps> = ({
  isAccessGrantingInProgress,
  isTermsAndConditionsAccepted,
  setIsTermsAndConditionsAccepted
}) => {
  const history = useHistory();
  const { styles: { colorHeading } } = useTheme();
  const { translateToString } = useTranslate();

  const agreementText = translateToString(terms_and_conditions_agreement_text);
  const linkText = translateToString(terms_and_conditions_agreement_document_link_text);
  const parts = agreementText.split('${terms_and_conditions_agreement_document_link_text}');
  const hasPlaceholder = parts.length > 1;

  return (
    <Container
      data-testid="termsOfServiceCheck"
      role="button"
      tabIndex={0}
      onClick={() => {
        // Disable checkbox after user has clicked "Continue"
        if (isAccessGrantingInProgress) return;

        setIsTermsAndConditionsAccepted(!isTermsAndConditionsAccepted);
      }}
    >
      <CheckboxWrapper>
        <Checkbox
          checked={isTermsAndConditionsAccepted}
        />
      </CheckboxWrapper>
      <TextWrapper>
        {hasPlaceholder ? (
          <>
            {parts[0]}
            <TermsOfConditionsPdf
              data-testid="termsAndConditionsBtn"
              onClick={() => {
                history.push(Paths.termsOfConditionsPdf);
              }}
              color={colorHeading}
            >
              {linkText}
            </TermsOfConditionsPdf>
            {parts[1]}
          </>
        ) : (
          <>
            {agreementText}&nbsp;
            <TermsOfConditionsPdf
              data-testid="termsAndConditionsBtn"
              onClick={() => {
                history.push(Paths.termsOfConditionsPdf);
              }}
              color={colorHeading}
            >
              {linkText}
            </TermsOfConditionsPdf>
          </>
        )}
      </TextWrapper>
    </Container>
  );
};

export { TermsAndConditions };
